import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  Pagination,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  CircularProgress
} from '@mui/material';

// components
import Iconify from '../components/iconify';
import CustomModal from '../components/modal/CustomModal';


// hooks

import { useAxios } from '../context/AxiosHookContext';

// sections
import { UserListHead } from '../sections/@dashboard/user';

// form
import { FormCreateCheckbook } from "../components/forms/checkbookForms/createCheckbook"
import { useNotification } from '../context/NotificationContext';

// utils

import { fCurrency } from "../utils/formatNumber"
import { formatoFechaAmFm } from "../context/DateInstance"

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '', label: 'CUENTA CONTABLE', alignRight: false },
  { id: '', label: 'CUENTA BANCARIA', alignRight: false },
  { id: '', label: 'CK#', alignRight: false },
  { id: '', label: 'COMENTARIO', alignRight: false },
  { id: '', label: 'MONTO', alignRight: false },
  { id: '', label: 'SALIDA', alignRight: false },
  { id: '', label: 'FECHA', alignRight: false },
  { id: '' }
];

// ----------------------------------------------------------------------

export default function Checkbooks() {

  const [open, setOpen] = useState(null);
  const [filterName, setFilterName] = useState('');

  const { showSnackbar } = useNotification()
  const navigate = useNavigate();

  const [openModaWorkBookAccounts, setOpenModalWorkBook] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState(false)
  const [workBookList, setWorkBookList] = useState([])
  const [valuesToEdit, setValuesToEdit] = useState({})

  const USERS_API = `/users?page=${page}&limit=10&displayName=${filterName}`
  const axios = useAxios();

  const handleOpenMenu = (event, values) => {
    setOpen(event.currentTarget);
    setValuesToEdit(values)
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };


  const getWorkbook = useCallback(async () => {
    try {
      setWorkBookList([])
      setLoading(true);
      const { data } = await axios.get("/checkbook/all");
      setWorkBookList(data.data);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, USERS_API, setWorkBookList, setLoading]);


  useEffect(() => {
    getWorkbook();
  }, [getWorkbook])


  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };


  return (
    <>
      <Helmet>
        <title>Cuentas de banco | {process.env.REACT_APP_APP_NAME} </title>
      </Helmet>

 
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Impresión de cheques
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => setOpenModalWorkBook(true)} >
            {"Generar"}
          </Button>
        </Stack>

        <Card>


          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                headLabel={TABLE_HEAD}
              />
              <TableBody>
                {workBookList?.map((row) =>

                (
                  <TableRow hover key={row._id} tabIndex={-1} role="checkbox">

                    <TableCell component="th" scope="row" padding="normal">
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Typography variant="subtitle2" noWrap>
                          {row?.checkbook_account?.account_code || "N/A"}
                        </Typography>
                      </Stack>
                    </TableCell>

                    <TableCell align="left">
                      {row?.checkbook_account?.account_name || "N/A"}
                    </TableCell>

                    <TableCell align="left">
                      {row?.checkbook_account?.account_sequence || "N/A"}
                    </TableCell>

                    <TableCell align="left">
                      {row?.checkbook_comment || "N/A"}
                    </TableCell>

                    <TableCell align="left">
                      {fCurrency(row.amount)}
                    </TableCell>

                    <TableCell align="left">
                      {row.output}
                    </TableCell>


                    <TableCell align="left">
                      {formatoFechaAmFm(row.created_date)}
                    </TableCell>

                    <TableCell align="right">
                      <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                        <Iconify icon={'eva:more-vertical-fill'} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

              {
                loading === true &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

              {
                (workBookList.length === 0 && loading === false) &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <Typography variant="h6" paragraph>
                          Sin resultados
                        </Typography>

                        <Typography variant="body2">
                          No se encontraron resultados para
                          <br /> Intente con otra búsqueda.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

            </Table>
          </TableContainer>

          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}

            sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
          />


        </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => {
          navigate('/printWorkbookPage', { state: {valuesToEdit}});
        }} >
          <Iconify icon={'eva:printer-fill'} sx={{ mr: 2 }} />
          Imprimir
        </MenuItem>
      </Popover>

      <CustomModal
        open={openModaWorkBookAccounts}
        modalStyle={{ maxWidth: 800, minWidth: 440 }}
        title={"Formulario de cheques"}
      >
        <FormCreateCheckbook
          onClose={() => setOpenModalWorkBook(false)}
          getValues={() => {
            getWorkbook();
            setOpenModalWorkBook(false);
            setValuesToEdit({});
            setOpen(null);
          }}
          valuesToEdit={valuesToEdit}
        />
      </CustomModal>
    </>
  );
}
